module.exports = __webpack_public_path__ + "static/media/rapidNaming-norming-intro1.6bdec9b0.mp3";